import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authError, setAuthError] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true, timeout: 20000 });
      setUser(data);
      setAuthError(false);
      return data;
    } catch (e) {
      // Só 401/403 significam "sem sessão"; falhas de rede não devem expulsar o utilizador.
      const st = e?.response?.status;
      if (st === 401 || st === 403) { setUser(null); setAuthError(false); }
      else setAuthError(true);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Páginas públicas (portal, assinatura) não usam sessão profissional.
    if (/^\/(portal|sign)\//.test(window.location.pathname)) { setLoading(false); return; }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch { /* ignore */ }
    setUser(null);
    window.location.href = "/login";
  };

  const loginWithGoogle = () => {
    const redirect = `${window.location.origin}/auth/callback`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <AuthContext.Provider value={{ user, loading, authError, refresh, logout, loginWithGoogle, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth fora de AuthProvider");
  return ctx;
}
